import packageJson from '../../package.json';

// ------------------------------------------------------------
// Application release version (synced from repo VERSION on deploy)
// ------------------------------------------------------------

export const APP_VERSION = packageJson.version;
